import { AppleStore, CHPlay, QR } from "../assets/images"
import QRCode from "react-qr-code";

const Download = () => {
    return (
        <div className="w-full h-full relative bg-bannerDownload bg-cover bg-no-repeat bg-center">
            <div className="w-full h-full relative lg:container lg:pt-[120px] space-y-4">
                <div className="w-full grid grid-cols-12 items-center h-full max-lg:px-4">
                    <div className="lg:col-span-8 lg:col-start-3 lg:flex items-center justify-between grid-cols-2 max-lg:col-span-full">
                        <div className="space-y-4 col-span-1 max-lg:col-span-full">
                            <p className="text-[80px] max-lg:text-[32px] text-white font-saira font-normal lg:block hidden">Download</p>
                            <p className="text-[80px] max-lg:text-[32px] text-white font-saira font-normal max-lg:block hidden text-center">Download Free</p>
                            <div onClick={() => window.open("https://apps.apple.com/vn/app/calmee/id6748893712", "_blank")} className="flex items-center justify-center gap-x-2 px-2 py-4 rounded-3xl bg-[#FFFFFF26] backdrop-blur-[27.6] cursor-pointer">
                                <img src={AppleStore} />
                                <p className="text-[16px] text-white font-sf">Download on the App Store</p>
                            </div>
                            <div className="qr-code-download mx-auto">
                                <QRCode 
                                size={256}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                viewBox={`0 0 256 256`}
                                value="https://apps.apple.com/vn/app/calmee/id6748893712" />
                            </div>
                            
                        </div>
                        <div className="space-y-4 col-span-1 max-lg:col-span-full">
                            <p className="text-[80px] max-lg:text-[32px] text-white font-saira font-extrabold max-lg:hidden">Free</p>
                            <div onClick={() => window.open("https://play.google.com/store/apps/details?id=com.viyume.calmee", "_blank")} className="flex items-center justify-center gap-x-2 px-2 py-4 rounded-3xl bg-[#FFFFFF26] backdrop-blur-[27.6] cursor-pointer">
                                <img src={CHPlay} />
                                <p className="text-[16px] text-white font-sf">Get it on Google Play</p>
                            </div>
                            <div className="max-lg:p-4 max-lg:bg-[#00000052] max-lg:backdrop-blur-[27.6] max-lg:rounded-3xl">
                                <div className="qr-code-download mx-auto">
                                    <QRCode 
                                    size={256}
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                    viewBox={`0 0 256 256`}
                                    value="https://play.google.com/store/apps/details?id=com.viyume.calmee" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Download